import React from "react";



const SidebarFooter: React.FC = () => {
  

  return (
    <div className="sidebar-footer">
    <p>v. 1.0 - Beta</p>
</div>
  );
};

export default SidebarFooter;
